import * as React from "react";
import { useAppSelector } from "../store/index";
import { useParams } from "react-router-dom";
import { RootState } from "../reducers/index";
import { Helmet } from "react-helmet-async";
import { IMapOptions } from "../interfaces/mapoptions";
import { composePathRoot } from "../api/utility";

const MetaDataResults = () => {
    const mapoptions = useAppSelector<IMapOptions>((x: RootState) => x.mapoptions);
    const halfwayLocationNameLong = useAppSelector<string>((x: RootState) => x.halfway.locationNameLong);
    const { adr1, adr2, poiname, travel } = useParams();

    const pagetitle = mapoptions.title;

    let metadescription: string;

    if (halfwayLocationNameLong) {
        metadescription = "The halfway point between " +
            mapoptions.address1 +
            " and " +
            mapoptions.address2 +
            " is " +
            halfwayLocationNameLong +
            ". Find a place to meet halfway.";
    }
    else {
        metadescription = "Find the halfway point between " +
            mapoptions.address1 +
            " and " +
            mapoptions.address2 +
            ".";
    }

    // add canonical?
    let canonical: JSX.Element;
    if (mapoptions.mapType === 'static') {
        const rooturl = 'https://www.meetways.com/halfway' + composePathRoot(adr1, adr2, poiname, travel, null);
        canonical = (<React.Fragment>
            <link rel="canonical" href={rooturl} />
            <meta property="og:url" content={rooturl} />
        </React.Fragment>)
    }

    return (<Helmet>
        <title>{pagetitle}</title>
        {canonical}
        <meta property="og:title" content={pagetitle} />
        <meta name='description' content={metadescription} />
        <meta property="og:description" content={metadescription} />
        <meta property="og:image" content="https://www.meetways.com/images/assets/og-meetways-results-min.jpg" />
   </Helmet>);
};

export default MetaDataResults;
